export default {
      id: "instagram-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#instagram",
      toString: function () {
        return this.url;
      }
    }